<mat-stepper
    [orientation]="orientation"
    [linear]="false"
    [selectedIndex]="currentStep.index"
    (selectionChange)="onSelectionChange($event)"
>
    <mat-step *ngFor="let step of steps" [completed]="step.completed">
        <ng-template matStepLabel>{{ step.label }}</ng-template>
        <ng-container *ngTemplateOutlet="step.templateRef"></ng-container>
    </mat-step>
</mat-stepper>
